import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WRegistryView } from '@zola/svc-web-api-ts-client';

export function getRegistryBySlug(slug: string): Promise<WRegistryView> {
  return ApiService.get(`/web-registry-api/v1/registry/slug/${slug}`);
}
